<div [id]="field.attributes.id" class="radio-buttons rating-controls">
  @if (!field.attributes.isStarRating) { @for (option of options; track option)
  {
  <label class="rating-option">
    <input
      type="radio"
      [name]="field.name"
      [value]="option"
      [formControl]="field.control"
    />
  </label>
  } } @else { @for (option of options; track option) {
  <mat-icon
    class="star"
    [class.selected]="field.control.value >= option"
    (click)="onStarClick(option)"
  >
    {{ field.control.value >= option ? 'star' : 'star_border' }}
  </mat-icon>
  } }
</div>
